import { useState, useEffect } from 'react';
import { Pane, Text, Button, CogIcon, Heading, PhoneIcon, EnvelopeIcon, MapMarkerIcon, Image } from 'evergreen-ui';
import { CONTACT } from '../constants/contact';

const readCookieConsent = () => {
    const match = document.cookie.match(/(^| )cookie_consent=([^;]+)/);
    if (!match) return null;
    try { return JSON.parse(decodeURIComponent(match[2])); } catch { return null; }
};

const Footer = () => {
    const [mapAllowed, setMapAllowed] = useState(false);

    useEffect(() => {
        const check = () => {
            const consent = readCookieConsent();
            setMapAllowed(consent !== null && consent.preferences === true);
        };
        check();
        window.addEventListener('openCookiePreferences', check);
        // Ricontrolliamo anche dopo che il banner salva (evento custom)
        window.addEventListener('cookieConsentSaved', check);
        return () => {
            window.removeEventListener('openCookiePreferences', check);
            window.removeEventListener('cookieConsentSaved', check);
        };
    }, []);

    const openCookieSettings = () => {
        if (typeof window !== 'undefined' && typeof window.openCookiePreferences === 'function') {
            window.openCookiePreferences();
        } else {
            const ev = new CustomEvent('openCookiePreferences');
            window.dispatchEvent(ev);
        }
    };

    return (
        <Pane is="footer" background="tint1" borderTop="muted" marginTop={24} display="flex" flexDirection="column" alignItems="center">
            <Pane width="100%" maxWidth={1000} paddingY={40} paddingX={20} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={40}>
                <Pane display="flex" flexDirection="column" gap={16}>
                  <Heading size={600}>Contattaci</Heading>
                  <Pane borderBottom="muted" paddingBottom={8}>
                    <Text display="flex" alignItems="center" gap={8}><PhoneIcon color="muted" /> {CONTACT.phone}</Text>
                  </Pane>
                  <Pane borderBottom="muted" paddingBottom={8}>
                    <Text display="flex" alignItems="center" gap={8}><EnvelopeIcon color="muted" /> {CONTACT.email}</Text>
                  </Pane>
                  <Pane display="flex" alignItems="center" gap={8}>
                    <MapMarkerIcon color="muted" />
                    <Text> {CONTACT.addressLabel}</Text>
                  </Pane>
                </Pane>
                
                {/* Mappa Google — visibile solo con consenso ai cookie di preferenza */}
                <Pane width={300} height={200} borderRadius={4} overflow="hidden">
                  {mapAllowed ? (
                    <iframe
                        src={CONTACT.mapEmbedSrc}
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Mappa Casa Letizia Collegno Footer"
                    />
                  ) : (
                    <Pane
                        width="100%"
                        height="100%"
                        background="tint2"
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        gap={8}
                        paddingX={12}
                    >
                        <MapMarkerIcon color="muted" size={24} />
                        <Text size={300} color="muted" textAlign="center">
                            Abilita i cookie di preferenza per visualizzare la mappa.
                        </Text>
                        <Button size="small" appearance="minimal" iconBefore={CogIcon} onClick={openCookieSettings}>
                            Impostazioni cookie
                        </Button>
                    </Pane>
                  )}
                </Pane>
            </Pane>
            
            <Pane
                width="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                padding={24}
                background="tint2"
                borderTop
                gap={16}
            >
                {/* Logo Abracadabra centrato */}
                <Pane display="flex" alignItems="center" gap={12}>
                    <Image src="/logo_abracadabra.png" alt="Logo Abracadabra" height={60} borderRadius={8} />
                </Pane>

                <Pane display="flex" justifyContent="center" alignItems="center" flexWrap="wrap" gap={16}>
                    <Text size={400} color="muted">
                        &copy; 2026 All rights reserved. Casa Letizia GAAG P.IVA 13037730010
                    </Text>
                </Pane>
                <Pane display="flex" justifyContent="center" alignItems="center" flexWrap="wrap" gap={24} marginTop={8}>
                    <Button appearance="minimal" is="a" href="/privacy">
                        Privacy Policy
                    </Button>
                    <Button appearance="minimal" is="a" href="/cookie-policy">
                        Cookie Policy
                    </Button>
                    <Button appearance="minimal" is="a" href="/terms">
                        Termini e Condizioni
                    </Button>
                    <Button appearance="minimal" iconBefore={CogIcon} onClick={openCookieSettings}>
                        Impostazioni cookie
                    </Button>
                </Pane>
            </Pane>
        </Pane>
    );
}

export default Footer;